module.exports = __webpack_public_path__ + "img/sc-3-act.67e161e9.png";